import { EInvoiceAddressSchemeType } from '@components'

import { Input } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'

export const VatNumber = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem, watch, setValue } = customerForm

  const currentEInvoiceSchemeType = watch('eInvoiceAddress.scheme')

  const handleVatNumberChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue('vatNumber', event.target.value)
      if (currentEInvoiceSchemeType === EInvoiceAddressSchemeType.VAT) {
        setValue('eInvoiceAddress.address', event.target.value)
      }
    },
    [setValue, currentEInvoiceSchemeType],
  )

  return (
    <FormItem
      label={t('customer_modal.form.vat_number.label')}
      name="vatNumber"
      render={({ field }) => <Input {...field} onChange={handleVatNumberChange} size="sm" />}
    />
  )
}
